import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Stack, Text} from '@chakra-ui/react'
import {useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage, useIntl} from 'react-intl'
import {remCalc} from '../../theme/_utils'
import {
    A3EnergyIcon,
    A2EnergyIcon,
    A1EnergyIcon,
    AEnergyIcon,
    BEnergyIcon,
    CEnergyIcon,
    DEnergyIcon,
} from '../icons'

const EnergyLabel = ({
    description,
    level,
    labelPosition = 'top',
    iconSize = 'big',
    textWidth = 'big',
    textSize = 'big',
    width = 'unset',
    justifyContent = 'unset',
    extraStyleDescription = {},
    isPlp = false,
    isBundle = false,
}) => {
    const style = useMultiStyleConfig('EnergyLabel', {
        labelPosition,
        iconSize,
        textWidth,
        textSize,
        width,
        justifyContent,
    })

    const intl = useIntl()

    const levelComponents = {
        'A+++': A3EnergyIcon,
        'A++': A2EnergyIcon,
        'A+': A1EnergyIcon,
        A: AEnergyIcon,
        B: BEnergyIcon,
        C: CEnergyIcon,
        D: DEnergyIcon,
    }
    const LevelComponent = levelComponents[level]

    const ariaLabel = intl.formatMessage(
        {
            id: 'energy_label.aria_label',
            defaultMessage: 'Energy efficiency {level}',
            description: 'Accessibility label for energy efficiency rating',
        },
        {level, clickAction: ''},
    )

    return isPlp ? (
        <Flex role="img" aria-label={ariaLabel}>
            {LevelComponent && <LevelComponent width={remCalc(42)} height={remCalc(22)} />}
        </Flex>
    ) : isBundle && LevelComponent ? (
        <Flex {...style.energyLabelContainer} role="img" aria-label={ariaLabel}>
            <LevelComponent width="42px" height="22px" />
            <Text {...style.energyLabelText}>
                <FormattedMessage
                    id="flexible_bundle.product_information"
                    defaultMessage="Product information"
                />
            </Text>
        </Flex>
    ) : (
        <Stack {...style.container}>
            {description && (
                <Text {...style.description} {...extraStyleDescription}>
                    {description}
                </Text>
            )}
            <Box {...style.labelIcon} role="img" aria-label={ariaLabel}>
                {LevelComponent && <LevelComponent {...style.icon} />}
            </Box>
        </Stack>
    )
}

EnergyLabel.propTypes = {
    description: PropTypes.string,
    level: PropTypes.string,
    labelPosition: PropTypes.oneOf(['top', 'left']),
    iconSize: PropTypes.oneOf(['big', 'small']),
    textWidth: PropTypes.oneOf(['big', 'medium', 'small']),
    textSize: PropTypes.oneOf(['big', 'small']),
    justifyContent: PropTypes.string,
    width: PropTypes.string,
    extraStyleDescription: PropTypes.object,
    isPlp: PropTypes.bool,
    isBundle: PropTypes.bool,
}

export default EnergyLabel
